<template>
  <div
    class="mx-auto grid max-w-7xl grid-cols-4 gap-4 px-4 sm:px-6 lg:mt-10 lg:gap-6 lg:px-8"
  >
    <div class="col-span-4 lg:col-span-3">
      <div>
        <img
          class="h-48 w-full object-cover object-center pb-1 sm:h-[36rem] lg:w-full"
          :src="imageUrl"
          :alt="imageAlt"
        />
      </div>
      <div class="">
        <h1
          class="mt-5 text-xl font-extrabold tracking-tight sm:text-2xl md:text-3xl"
        >
          <span class="text-blue-ribbon-500">{{ title }}</span>
        </h1>
        <p
          v-if="displayDate"
          class="mt-3 text-xs text-gray-500 sm:text-sm md:text-base"
        >
          Published:
          {{
            new Intl.DateTimeFormat('en-GB', {
              dateStyle: 'long'
            }).format(new Date(date))
          }}
        </p>
        <div class="prose mt-5 max-w-none" v-html="body" />
      </div>
    </div>
    <div class="hidden lg:block">
      <h2
        class="text-base font-semibold uppercase tracking-wide text-blue-ribbon-500"
      >
        Blog posts
      </h2>
      <div
        v-for="(post, postKey) in posts.slice(0, 8)"
        :key="`post-${postKey}`"
        class="mt-4 mb-6 flex w-full flex-col rounded border border-gray-100 bg-white shadow-lg hover:bg-gray-50"
      >
        <router-link :to="{ name: post.title }">
          <div v-if="postKey < 3">
            <img
              class="h-24 w-full rounded-t object-cover object-center"
              :src="post.coverImage.thumbnail"
              :alt="`Cover image for '${post.title}'`"
            />
            <div class="flex grow flex-col px-3 py-2">
              <h3
                class="mb-2 text-base font-semibold leading-snug text-blue-ribbon-500"
              >
                {{ post.title }}
              </h3>
              <p class="mb-2">
                <span class="text-sm text-gray-500 line-clamp-3">
                  {{ post.excerpt }}
                </span>
              </p>
            </div>
          </div>
          <div v-else class="flex flex-row">
            <img
              class="h-16 w-16 rounded-l object-cover object-center"
              :src="post.coverImage.url"
              :alt="`Cover image for '${post.title}'`"
            />
            <div class="px-2">
              <h3
                class="text-sm font-semibold leading-snug text-blue-ribbon-500 line-clamp-3"
              >
                {{ post.title }}
              </h3>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="col-span-4 mt-5 flex justify-center">
      <Registration :animated="true" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@vueuse/head'

import Registration from '@/components/Registration.vue'
import { posts } from './../graphcms/content.json'
import { onUpdated } from 'vue'

const props = defineProps([
  'slug',
  'displayDate',
  'date',
  'title',
  'excerpt',
  'body',
  'imageUrl',
  'imageAlt',
  'imageWidth',
  'imageHeight'
])

onUpdated(() => {
  document.title = `${props.title} - GaragesNear.me`
})

useHead({
  title: `${props.title} - GaragesNear.me`,
  meta: [
    {
      name: 'og:title',
      content: `${props.title} - GaragesNear.me`
    },
    {
      name: 'description',
      content: props.excerpt
    },
    {
      name: 'og:description',
      content: props.excerpt
    },
    {
      name: 'og:image',
      // content: props.imageUrl
      content: `/open-graph/${props.slug}.webp`
    },
    {
      name: 'og:image:alt',
      content: `Cover image for '${props.title}'`
    },
    {
      name: 'og:image:width',
      // content: props.imageWidth
      content: 1280
    },
    {
      name: 'og:image:height',
      // content: props.imageWidth
      content: 576
    }
  ]
})
</script>
